<template>
  <div>
    <h2 id="mainText" class="atitle">
      Let's create something awesome
    </h2>
    <div class="text-center mt-4 mb-2">
      <button class="btn btn-light mr-1 mb-2">
        <h4 class="mb-0" v-on:click="$router.push('about')">What are we about?</h4>
      </button>
      <button class="btn btn-light ml-1 mb-2">
        <h4 class="mb-0" v-on:click="$router.push('contact')">Let's get started!</h4>
      </button>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: "home",
  components: {},
};
</script>

<style>
.btn.btn-light {
  background-color: transparent;
  color: whitesmoke;
}

@media screen and (max-width: 500px){
  #mainText {padding-top: 12rem;}
}

@media screen and (min-width: 500px){
  #mainText {padding-top: 20rem;}
}
</style>
